export const setPlace = (place) => ({
  type: "place",
  payload: place
});
export const Home = () => ({
  type: "Home",
});
export const Hotel = () => ({
  type: "Hotel",
});
export const _Flight_ = () => ({
  type: "Flight",
});
export const Car_Rentals = () => ({
  type: "Car Rentals",
});
export const Restaurants = () => ({
  type: "Restaurants",
});
export const Things_to_do = () => ({
  type: "Things to do",
});
export const Audio_Tour = () => ({
  type: "Audio Tour",
});
export const _Deals_ = () => ({
  type: "Deals",
});
export const _Blog_ = () => ({
  type: "Blog",
});
export const _Demo_ = () => ({
  type: "Demo",
});

export const CLEAR_PLACE = "CLEAR_PLACE";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const openModal = (data) => ({
  type: OPEN_MODAL,
  payload: data,
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});


export const clearPlace = () => ({
  type: CLEAR_PLACE,
});